import { FC } from 'react';

export const KeyboardSpacing: FC<React.PropsWithChildren<unknown>> = () => null;
